module.exports = require('@dooer/errors')([['failed-validation', 400]])
